import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Upload } from './../../../components/includes/upload';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { BannersService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {}

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 255){
    errors.name = 'El tamaño máximo es de 255 caracteres.';
  }

  return errors

};

class BannerCreate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      sending: false,
      upload: false
    };
  }

  componentDidMount(){

  }

  /*
  ** @Service
  ** @Description: New
  */

  _Create = (values) => {

    BannersService.create(values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/banners');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el banner fue creado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  handleSubmitForm = (values) => {
    this._Create(values);
  }

  /*
  ** @Service
  ** @Description: Attachments
  */

  onUploadImagenLarge = (file) => {
    this.props.dispatch(change('BannerCreate', 'image_large', file.attachment[0] ));
  }

  onUploadImagenMedium = (file) => {
    this.props.dispatch(change('BannerCreate', 'image_medium', file.attachment[0] ));
  }

  onUploadImagenSmall = (file) => {
    this.props.dispatch(change('BannerCreate', 'image_small', file.attachment[0] ));
  }

  render() {

    const { sending } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Banners"/>
        <BreadcrumbItem to='/banners'>Banners</BreadcrumbItem>
        <BreadcrumbItem to='/banners/create'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

              <Ttolbar title="Creación de banners"/>

              <FormContent enabledActions>

                <Grid container spacing={24}>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="name"
                        component={ InputTextField }
                        label="Nombre"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="status"
                        component={ SelectField }
                        label="Estado" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="true" value="true">Activo</OptionField>
                          <OptionField key="false" value="false">Bloqueado</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Field
                        name="link_url"
                        component={ InputTextField }
                        label="Enlace"
                        type="text"
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Field
                        name="link_target"
                        component={ SelectField }
                        label="Apertura">
                          <OptionField key="_self" value="_self">Misma Página</OptionField>
                          <OptionField key="_blank" value="_blank">Nueva Página</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Field
                        name="image_large"
                        type="hidden"
                        component={ InputTextField }
                    />
                    <Upload
                      button="Subir imagen"
                      onSuccess={ this.onUploadImagenLarge.bind(this) }
                    />
                  </Grid>

                </Grid>

              </FormContent>

              <FormActions>
                <Grid container>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons>
                      <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/banners">
                        Volver
                      </Btn>
                    </Buttons>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons align="right">
                      <Btn aria-label="Guardar banner" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                        Guardar banner
                      </Btn>
                    </Buttons>
                  </Grid>
                </Grid>
              </FormActions>

            </form>

          </Main>

        </Content>
      </Section>
    )
  }
}

BannerCreate = reduxForm({
  form: 'BannerCreate',
  validate,
  initialValues: {
    status: '-1',
    link_target: '_self'
  }
})(BannerCreate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BannerCreate);
